import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"

// import { useVoiceMsg } from '../contexts/VoiceMsgContext'
import { useUser } from "../contexts/UserContext"
import { FaTimes } from "react-icons/fa"
import { RiSearch2Line } from "react-icons/ri"
import { HiOutlineArrowNarrowUp } from "react-icons/hi"

function SearchComponent({ className, toggleInput, setShowPage }) {
    const history = useHistory()
    const user = useUser()
    // const voiceMsg = useVoiceMsg()
    const [ searchContent, setSearchContent ] = useState( "" )
    const [ diets, setDiets ] = useState({})
    const [ intolerance, setIntolerance ] = useState({})
    const [ showOptions, setShowOptions ] = useState( false )
    const [ animate, setAnimate ] = useState( false )

    // useEffect(() => {
    //     setSearchContent( voiceMsg || "" )
    // }, [voiceMsg])

    useEffect(() => {
        const inputs = document.querySelectorAll( "input[type=checkbox]" )
        let storedDiets = {}
        let storedIntolerance = {}

        if ( localStorage.getItem(`${user?.uid}-diets`) || localStorage.getItem(`${user?.uid}-intolerance`) ) {
            storedDiets = JSON.parse(localStorage.getItem(`${user?.uid}-diets`))
            storedIntolerance = JSON.parse(localStorage.getItem(`${user?.uid}-intolerance`))
        }
        
        if ( storedDiets !== null ) {
            Object?.entries(storedDiets)?.forEach( ([key, value]) => {
                inputs.forEach( input => {
                    if ( value !== "" && input.value === key ) {
                        input.checked = true
                    }
                })
                return
            })
        }

        if ( storedIntolerance !== null ) {
            Object?.entries(storedIntolerance)?.forEach( ([key, value]) => {
                inputs.forEach( input => {
                    if ( value !== "" && input.value === key ) {
                        input.checked = true
                    }
                })
                return
            })
        }
    }, [user?.uid, showOptions])

    const handleChange = (e) => {
        if ( e.target.type === "checkbox"  ) {
            if ( e.target.parentElement.className === "dietOptions"  ) {
                if ( e.target.checked ) {
                    storeData( `${user?.uid}-diets`, { ...diets, [e.target.name]: e.target.value } )
                } else {
                    e.target.value = ""
                    storeData( `${user?.uid}-diets`, { ...diets, [e.target.name]: e.target.value } )
                }
                setDiets({ ...diets, [e.target.name]: e.target.value })
            } else {
                if ( e.target.checked ) {
                    storeData( `${user?.uid}-intolerance`, { ...intolerance, [e.target.name]: e.target.value } )
                } else {
                    e.target.value = ""
                    storeData( `${user?.uid}-intolerance`, { ...intolerance, [e.target.name]: e.target.value } )
                }
                setIntolerance({ ...intolerance, [e.target.name]: e.target.value }) 
            }
        } else { 
            setSearchContent( e.target.value )
        }
        // e.target.type === "checkbox" 
        // ? e.target.parentElement.className === "dietOptions" 
        //     ? setDiets({ ...diets, [e.target.name]: e.target.value }) 
        //     : setIntolerance({ ...intolerance, [e.target.name]: e.target.value }) 
        // : setSearchContent( e.target.value )
    }
    
    const handleSearch = (e) => {
        e.preventDefault() 
        const ingredientQuery = searchContent.split("%20").join( ",+" ).toLowerCase()
        let dietQuery = ""
        let intoleranceQuery = ""
        let arr = []
        Object.entries(diets).forEach( ([key, value]) => {
            if ( value !== "" ) {
                dietQuery += `${key} `
            }
            return
        })
        Object.entries(intolerance).forEach( ([key, value]) => {
            if ( value !== "" ) {
                arr.push( `${key} free` )
                intoleranceQuery = arr.join(",")
            }
            return
        })

        setShowPage && setShowPage( false )

        if ( searchContent === null || searchContent === "" ) {
            alert( "Input can't be empty" )
        } else if ( searchContent.match( /[0-9]/ ) ) {
            alert( "Ingredients should be a string" )
        } else if ( searchContent.match( /[^a-zA-Z\d\s]/u ) ) {
            alert( "Ingredient list shouldn't contain any special character" )
        } else {
            history.replace( `/search/${ingredientQuery}&diet=${dietQuery.trim().split( " " ).join( "," )}&intolerances=${intoleranceQuery}` )
            setShowPage && setShowPage( false )
            setShowOptions( false )
        }

        setSearchContent( "" )
        setDiets({ vegetarian: "", vegan: "", gluten: "", ketogenic: "" }) 
        setIntolerance({ dairy: "", egg: "", peanut: "", seafood: "", wheat: "" }) 
    }

    const handleShowOptions = () => {
        setShowOptions( true )
        setAnimate( true )
    }
    const handleHideOptions = (e) => {
        e.preventDefault()
        setTimeout(function() {
            setShowOptions( false )
            setAnimate( false )
        }, 100)
    }

    const storeData = (key, data) => localStorage.setItem( key, JSON.stringify(data) )

    return (
        <>
            {
                className === "searchModal animate" || className === "searchModal"
                    ? <div className={className} >
                        <button id="closeModalBtn"  onClick={toggleInput}><FaTimes size="20px" /></button>
                        <form onSubmit={handleSearch} >
                            <section>
                                <input 
                                    className="searchInput" 
                                    type="text" 
                                    placeholder="potato bread..." 
                                    aria-label="Search Input"
                                    value={searchContent}
                                    onChange={handleChange}
                                    required
                                />
                                <button type="submit" >
                                    <RiSearch2Line className="searchBtn" title="Search Icon" size="18px" />
                                </button>
                            </section>
                        
                            <section className="dietOptions" >
                                <h3>Diets</h3>
                                <input 
                                    type="checkbox" 
                                    name="vegetarian" 
                                    value="vegetarian" 
                                    aria-label="Vegetarian" 
                                    onChange={handleChange} />
                                <label htmlFor="vegetarian">Vegetarian</label>
                                <br />
    
                                <input 
                                    type="checkbox" 
                                    name="vegan" 
                                    value="vegan" 
                                    aria-label="Vegan"
                                    onChange={handleChange} />
                                <label htmlFor="vegan">Vegan</label>
                                <br />
    
                                <input 
                                    type="checkbox" 
                                    name="gluten" 
                                    value="gluten" 
                                    aria-label="Gluten Free"
                                    onChange={handleChange} />
                                <label htmlFor="gluten">Gluten Free</label>
                                <br />
    
                                <input 
                                    type="checkbox" 
                                    name="ketogenic" 
                                    value="ketogenic" 
                                    aria-label="Ketogenic"
                                    onChange={handleChange} />
                                <label htmlFor="ketogenic">Ketogenic</label>
                                <br />
                            </section>
                            <section className="intoleranceOptions" >
                                <h3>Intolerances</h3>
                                <input 
                                    type="checkbox" 
                                    name="dairy" 
                                    value="dairy" 
                                    aria-label="Dairy"
                                    onChange={handleChange} />
                                <label htmlFor="dairy">Dairy Free</label>
                                <br />
    
                                <input 
                                    type="checkbox" 
                                    name="egg" 
                                    value="egg" 
                                    aria-label="Egg"
                                    onChange={handleChange} />
                                <label htmlFor="egg">Egg Free</label>
                                <br />
    
                                <input 
                                    type="checkbox" 
                                    name="peanut" 
                                    value="peanut" 
                                    aria-label="Peanut"
                                    onChange={handleChange} />
                                <label htmlFor="egg">Peanut Free</label>
                                <br />
    
                                <input 
                                    type="checkbox" 
                                    name="seafood" 
                                    value="seafood" 
                                    aria-label="Seafood"
                                    onChange={handleChange} />
                                <label htmlFor="seafood">Seafood Free</label>
                                <br />
    
                                <input 
                                    type="checkbox" 
                                    name="wheat" 
                                    value="wheat" 
                                    aria-label="Wheat"
                                    onChange={handleChange} />
                                <label htmlFor="wheat">Wheat Free</label>
                                <br />
                            </section>
                        </form>
                    </div>

                    : <div className={className} >
                        <form>
                            <section>
                                <input 
                                    className="searchInput" 
                                    type="text" 
                                    placeholder="Ingredients separated by white space" 
                                    aria-label="Search Input"
                                    value={searchContent}
                                    onChange={handleChange}
                                    onFocus={handleShowOptions}
                                    required
                                />
                                <button onClick={handleSearch} >
                                    <RiSearch2Line className="searchBtn" title="Search Icon" size="18px" />
                                </button>
                            </section>
                        
                            {
                                showOptions &&
                            <section className={animate ? "options animate" : "options"}>
                                <section className="dietOptions" >
                                    <h3>Diets</h3>
                                    <input 
                                        type="checkbox" 
                                        name="vegetarian" 
                                        value="vegetarian" 
                                        aria-label="Vegetarian" 
                                        onChange={handleChange} />
                                    <label htmlFor="vegetarian">Vegetarian</label>
                                    <br />
            
                                    <input 
                                        type="checkbox" 
                                        name="vegan" 
                                        value="vegan" 
                                        aria-label="Vegan"
                                        onChange={handleChange} />
                                    <label htmlFor="vegan">Vegan</label>
                                    <br />
            
                                    <input 
                                        type="checkbox" 
                                        name="gluten" 
                                        value="gluten" 
                                        aria-label="Gluten Free"
                                        onChange={handleChange} />
                                    <label htmlFor="gluten">Gluten Free</label>
                                    <br />
            
                                    <input 
                                        type="checkbox" 
                                        name="ketogenic" 
                                        value="ketogenic" 
                                        aria-label="Ketogenic"
                                        onChange={handleChange} />
                                    <label htmlFor="ketogenic">Ketogenic</label>
                                    <br />
                                </section>
                                <section className="intoleranceOptions" >
                                    <h3>Intolerances</h3>
                                    <input 
                                        type="checkbox" 
                                        name="dairy" 
                                        value="dairy" 
                                        aria-label="Dairy"
                                        onChange={handleChange} />
                                    <label htmlFor="dairy">Dairy Free</label>
                                    <br />
            
                                    <input 
                                        type="checkbox" 
                                        name="egg" 
                                        value="egg" 
                                        aria-label="Egg"
                                        onChange={handleChange} />
                                    <label htmlFor="egg">Egg Free</label>
                                    <br />
            
                                    <input 
                                        type="checkbox" 
                                        name="peanut" 
                                        value="peanut" 
                                        aria-label="Peanut"
                                        onChange={handleChange} />
                                    <label htmlFor="egg">Peanut Free</label>
                                    <br />
            
                                    <input 
                                        type="checkbox" 
                                        name="seafood" 
                                        value="seafood" 
                                        aria-label="Seafood"
                                        onChange={handleChange} />
                                    <label htmlFor="seafood">Seafood Free</label>
                                    <br />
            
                                    <input 
                                        type="checkbox" 
                                        name="wheat" 
                                        value="wheat" 
                                        aria-label="Wheat"
                                        onChange={handleChange} />
                                    <label htmlFor="wheat">Wheat Free</label>
                                    <br />
                                </section>

                                <button onClick={handleHideOptions}>
                                    <HiOutlineArrowNarrowUp size="18px" />
                                </button>
                            </section>
                            }
                        </form>
                    </div>
            }
        </>
    )
}

export default SearchComponent
